"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganizationGroupIds = void 0;
const react_1 = __importDefault(require("react"));
const exchange_api_client_1 = require("@mulesoft/exchange-api-client");
const config_1 = require("./config");
const errors_1 = require("./errors");
/**
 * Do a query to the API and fetch available groupIds for a given organizationId.
 *
 * @example
 *
 * ```tsx
 * import { useOrganizationGroupIds } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ organizationId }) => {
 *   const groupIds = useOrganizationGroupIds(organizationId);
 *
 *   ...
 * };
 * ```
 *
 * @param organizationId The target organization to get "groupId"s from
 * @returns A list of "groupId"s for the organization
 */
const useOrganizationGroupIds = (organizationId) => {
    const config = (0, config_1.useConfig)();
    const tryFn = (0, errors_1.useTryFn)();
    const assetService = new exchange_api_client_1.AssetService(config);
    const [groupIds, setGroupIds] = react_1.default.useState([]);
    react_1.default.useEffect(() => {
        tryFn((context) => assetService
            .getOrganizationGroupIds({ context, organizationId })
            .then(setGroupIds));
    }, [organizationId]);
    return groupIds;
};
exports.useOrganizationGroupIds = useOrganizationGroupIds;
